exports.baseURL = "https://admin.almasachatapp.chat/";
exports.key = "c30kf1dgy-5+b0yv(0n-ge2=f";
exports.projectName = "Almasa Chat";
